export default function getId(arg?: string) {
  return `${arg ? arg + "-" : ""}${Math.round(Math.random() * 1e5)}`;
}
